const React = require("react");

function ArrowNarrowLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 16l-4-4m0 0l4-4m-4 4h18"
  }));
}

module.exports = ArrowNarrowLeftIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ArrowNarrowLeftIcon.js
 ** module id = 438
 ** module chunks = 0
 **/